<template>
  <div id="profile" class="modal fade black-modal" role="dialog" data-backdrop="true" data-keyboard="false">
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <div class="sticky-top container-fluid" data-padding-right="" data-margin-right="" style="">
          <div class="align-items-center justify-content-center py-0 modalTopClose row">
            <div class="col-2">
              <button data-dismiss="modal" class="button-close mt-1">
                <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="arrow-left"
                  class="svg-inline--fa fa-arrow-left p-0 text-white" role="img" xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 448 512" style="font-size: 20px;">
                  <path fill="currentColor"
                    d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z">
                  </path>
                </svg>
              </button>
            </div>
            <div class="d-flex justify-content-center col-8">
              <a data-animatable="fadeInUp" data-delay="500" href="/">
                <div class="logo-title pt-1 img-fluid my-2">
                  <img alt="ZEAGAME แทงบอลออนไลน์ คาสิโนออนไลน์" loading="eager" width="190" height="48" decoding="async"
                    data-nimg="1" class="animated fadeInUp img-fluid" src="/static/img/logo/logo.png"
                    style="color: transparent;" />
                </div>
              </a>
            </div>
            <div class="text-right col-2">
              <button data-dismiss="modal" class="button-close">
                <img src="/static/img/landing/closeIcon.png" width="40" height="40" alt="ปิด" class="" />
              </button>
            </div>
          </div>
        </div>
        <div class="modal-header">
          <div class="container">
            <h5>ข้อมูลสมาชิก</h5>
          </div>
        </div>
        <div class="modal-body">
          <div class="py-4 container">
            <div class="detailuser">

              <div class=" modal-body" id="modal-account-detail">
                <div class="mb-4 text-center col"><img src="/static/img/landing/userIcon.png" width="50" height="50"
                    alt="ZEAGAME" class="mr-2">
                  <h4 class="d-inline mb-4">ข้อมูลสมาชิก</h4>
                </div>
                <div class="mx-auto align-items-center justify-content-center row">
                  <div class="topic col-5">ยูสเกมส์</div>
                  <div class="data col-7"><span>{{ UserInfo.PhoneNumber }}</span></div>
                </div>
                <div class="mx-auto align-items-center justify-content-center row">
                  <div class="topic col-5">เบอร์โทรศัพท์</div>
                  <div class="data col-7"><span> {{ UserInfo.PhoneNumber }}</span></div>
                </div>
                <div class="mx-auto align-items-center justify-content-center row">
                  <div class="topic col-5">ชื่อ-นามสกุล</div>
                  <div class="data col-7"><span>{{ UserInfo.userName.fullName }}</span></div>
                </div>
                <div class="mx-auto align-items-center justify-content-center row">
                  <div class="topic col-5">ธนาคาร</div>
                  <div class="data col-7"><span><img :style="{
                        'background-color': getBankColorwithCode(
                          UserInfo.BankCode
                        ),
                        padding:
                          UserInfo.BankCode == 'co.th.truemoney.wallet'
                            ? ''
                            : '5px',
                      }" v-bind:src="getBankImgwithCode(UserInfo.BankCode)" width="60" class="img-rounded img-responsive" /></span></div>
                </div>
                <div class="mx-auto align-items-center justify-content-center row">
                  <div class="topic col-5">เลขที่บัญชี</div>
                  <div class="data col-7"><span>{{ UserInfo.BankAccount | formatAccNo }}</span></div>
                </div>
               
              </div>

               
            </div>
          </div>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";
import { fetchAffiliate, WithdrawAffiliate } from "@/services/modules/af.js";
import MemberCard from "@/components/form/MemberCard";
import { fetchBonus } from "@/services/modules/promotion.js";
import api from "@/services/index.js";

export default {
  name: "ProfileForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],

  data() {
    return {
      amount: "",
      bonusName: "-",
      promotionList: [],
      affiliateLink: "",
    };
  },
  components: {
    MemberCard,
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPrefix",
    ]),
  },
  methods: {
    ...mapActions(["userSignOut"]),
    async sign_out() {
      this.userSignOut();
    },
    getDate: function (data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },
    async copybank(item) {
      this.$copyText(item, this.$refs.withdraw);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },

    async copyAF(item) {
      this.$copyText(item, this.$refs.af);
      this.$swal.fire("คัดลอกแล้ว", "", "success");
    },
    async fetchAffiliate() {
      await fetchAffiliate((res) => {
        if (res.status) {
          this.income = res.data.balance;
          this.Trans = res.data.transaction;
          this.Users = res.data.Users;
          this.TransIncome = res.data.transaction_incomes;
          this.setting = res.data.setting;
        }
      });
    },

    async WithdrawAffiliate() {
      await WithdrawAffiliate((res) => {
        if (res.status) {
          this.$swal.fire("Success!", "", "success");
        } else {
          this.$swal.fire(res.message, "", "error");
        }
      });
    },

    async PromotionData() {
      // this.setLoading(true)
      await fetchBonus((res) => {
        if (res.status) {
          this.promotionList = res.data;
        } else {
        }
      });
    },
    async getUserRefresh(Loading) {
      await api
        .get("/auth-service/v1/refresh")
        .then((v) => {
          if (this.UserInfo.BonusInfo.isBonus) {
            if (this.promotionList.length > 0) {
              let promotionItem = this.promotionList.find(
                (x) => x._id === this.UserInfo.BonusInfo.bonusId
              );
              if (promotionItem != undefined) {
                this.bonusName = promotionItem.title;
              } else {
                this.bonusName = "-";
              }
            }
          }
        })
        .catch((e) => {
          this.$swal.fire(e.status.message, "", "error");
        })
        .finally(() => { });
    },
  },
  async mounted() {
    await this.PromotionData();
    await this.fetchAffiliate();
    this.affiliateLink = "";
    this.affiliateLink =
      window.location.origin + "/" + this.UserInfo.affiliateKey;
    $(".overlaymodal").on("click", function () {
      $("#personalct").modal("hide");
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/form/ProfileForm.vue